import { defineMessages } from '@atlassian/jira-intl'; // TODO - Port i18n string translations to new module ID keys

// TODO - Port i18n string translations to new module ID keys
const messages: {
	tooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	tooltip: {
		id: 'issue-navigator.refresh-button.tooltip',
		defaultMessage: 'Refresh',
		description: 'The tooltip on refresh button on the issue list',
	},
	loading: {
		id: 'issue-navigator.refresh-button.loading',
		defaultMessage: 'Loading',
		description: 'The aria-label attribute for spinner on the issue list',
	},
});
export default messages;
